const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20cinematic%20scene%20with%20dynamic%20urban%20night%20setting%20and%20warm%20neon%20reflections%2C%20dramatic%20lighting%20with%20amber%20highlights%2C%20film%20grain%20texture%2C%20professional%20cinematography%2C%20dark%20moody%20atmosphere%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-01-6080&orientation=landscape',
    tag: '动作巨制',
    title: '暑期档动作大片精选',
    desc: '高燃打斗、震撼特效，肾上腺素飙升的观影体验，多部高分动作电影连播。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20still%20with%20soft%20golden%20hour%20lighting%20and%20warm%20amber%20tone%2C%20cinematic%20depth%20of%20field%20with%20dreamy%20bokeh%2C%20elegant%20composition%2C%20emotional%20atmosphere%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-02-6080&orientation=landscape',
    tag: '情感剧场',
    title: '治愈系高分文艺片',
    desc: '温暖人心的故事，细腻动人的表演，在光影中感受生活的温度与美好。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20concept%20art%20with%20holographic%20elements%20and%20sleek%20metallic%20surfaces%2C%20vast%20space%20nebula%20background%20with%20ambient%20glow%2C%20cinematic%20wide%20composition%2C%20high%20production%20value%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-03-6080&orientation=landscape',
    tag: '科幻世界',
    title: '年度科幻饕餮盛宴',
    desc: '硬核科幻设定、宏大世界观，带你穿越星际，探索未知宇宙的无尽想象。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20atmosphere%20with%20dramatic%20shadow%20play%20and%20dimly%20lit%20corridor%2C%20muted%20teal%20and%20amber%20color%20contrast%2C%20film%20noir%20aesthetic%2C%20cinematic%20tension%20and%20mystery%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-04-6080&orientation=landscape',
    tag: '悬疑迷局',
    title: '烧脑悬疑片单合集',
    desc: '反转再反转，每一帧都藏着线索，挑战你的推理极限，智商在线的观影选择。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20film%20set%20with%20warm%20cheerful%20lighting%20and%20vibrant%20production%20design%2C%20high-key%20photography%20style%2C%20dynamic%20energy%2C%20cinematic%20composition%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-05-6080&orientation=landscape',
    tag: '欢乐剧场',
    title: '爆笑喜剧快乐加倍',
    desc: '笑料不断、轻松解压，周末放松首选，多部高分喜剧让你开怀大笑不停。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20concept%20with%20painterly%20textures%20and%20dreamy%20atmosphere%2C%20soft%20watercolor%20background%20with%20golden%20light%20particles%2C%20whimsical%20fairy%20tale%20mood%2C%20cinematic%20framing%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-06-6080&orientation=landscape',
    tag: '动画天地',
    title: '全球热门动画集锦',
    desc: '顶级制作、视觉盛宴，无论儿童还是成人，都能找到属于你的动画世界。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选六大影视专题，总有一个合你口味
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={`6080新视觉影院 ${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/80 text-foreground-950 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-800 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}